import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { authReducer } from './auth';
import { loadingReducer } from './loading';
import { uiReducer } from './ui';
import { clientesReducer } from './clientes';
import { usuariosReducer } from './usuarios';
import { perfilReducer } from './perfil';
import { userReducer } from './user';
import { modalContainerReducer } from './modal-container';
import { vendedorReducer } from './vendedor';
import { produtoReducer } from './produto';
import {
  extracoesReducer,
  geolocalizacaoReducer,
  layoutExtracaoReducer,
  levantamentoQuantitativoReducer,
  listaCEPReducer,
  listaDeduplicacaoReducer,
  localizacaoReducer,
  ocupacaoReducer,
  projetosReducer,
  recorteExtracaoReducer,
  UFCountReducer,
  layoutRecorteReducer,
  listaCidadesReducer,
  CidadeUFReducer
} from './geo-veles';
import { produtoClienteReducer } from './produtoCliente';
import { travaConsumoReducer } from './geo-veles/trava_consumo';
import { listaCboReducer } from './geo-veles/lista-cbo';

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false
})

export const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    ui: uiReducer,
    clientes: clientesReducer,
    usuarios: usuariosReducer,
    perfil: perfilReducer,
    user: userReducer,
    modalContainer: modalContainerReducer,
    projetos: projetosReducer,
    localizacao: localizacaoReducer,
    listaCEP: listaCEPReducer,
    listaDeduplicacao: listaDeduplicacaoReducer,
    geolocalizacao: geolocalizacaoReducer,
    ocupacao: ocupacaoReducer,
    ufCount: UFCountReducer,
    recorteExtracao: recorteExtracaoReducer,
    extracoes: extracoesReducer,
    vendedor: vendedorReducer,
    produto: produtoReducer,
    produtoCliente: produtoClienteReducer,
    layoutExtracao: layoutExtracaoReducer,
    levantamentoQuantitativo: levantamentoQuantitativoReducer,
    travaConsumo: travaConsumoReducer,
    layoutRecorte: layoutRecorteReducer,
    listaCidades: listaCidadesReducer,
    cidadeUF: CidadeUFReducer,
    listaCbo: listaCboReducer,
  },
  middleware: customizedMiddleware
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;